import React from 'react'
import styled, { css } from 'styled-components'

import { getColor } from '../../utils/cssUtils'

const Container = styled.li`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 32px;
  height: 32px;
  line-height: 1;
  border-radius: 4px;
  border: 1px solid ${getColor('grey')};
  margin: 0 8px 8px 0;
  outline: none;
  cursor: pointer;
  transition: all 0.3s;
  ${({ active }) =>
    active &&
    css`
      border-color: ${getColor('theme')};
      background-color: ${getColor('theme')};
    `}
  ${({ disabled }) =>
    disabled
      ? css`
          cursor: not-allowed;
          border-color: ${getColor('lightGrey')};
          color: ${getColor('lightGrey')};
        `
      : css`
          &:hover {
            border-color: ${getColor('pink')};
            color: ${getColor('pink')};
          }
        `}
`
const PageLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  outline: none;
  ${({ active }) =>
    active &&
    css`
      color: #fff;
    `}
`

const Page = ({
  title,
  active,
  disabled,
  onClick,
  children,
  className,
  'data-test-id': dataTestId
}) => {
  return (
    <Container
      active={active}
      disabled={disabled}
      className={className}
      data-test-id={dataTestId}
    >
      <PageLink
        title={title}
        active={active}
        disabled={disabled}
        onClick={onClick}
        data-test-id='pagination-link'
      >
        {children}
      </PageLink>
    </Container>
  )
}

export default React.memo(Page)
